import axios from "axios";
import React, { useEffect, useState } from "react";
import createAppStore from "../redux/store";
import Loader from "../common/loader/Loader";
import { Provider } from "react-redux";

import App from "../App";
import ScrollToTop from "../middlewares/ScrollToTop";

// const BASE_URL = "https://gba-test.azurewebsites.net";
const BASE_URL = "https://gba2.azurewebsites.net";
// const BASE_URL = "http://localhost:3500";

function ErrorComponent({ errorMessage }) {
  return (
    <div className="text-red-500 font-bold text-center">{errorMessage}</div>
  );
}

function AppContainer() {
  const [store, setStore] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [serverError, setServerError] = useState(null);

  useEffect(() => {
    const checkServerStatus = async () => {
      try {
        await axios.get(`${BASE_URL}/server-status`);
      } catch (err) {
        setServerError("Server is down. Please try again later.");
      }
    };
    checkServerStatus();
  }, []);

  useEffect(() => {
    const initializeStore = async () => {
      try {
        const appStore = await createAppStore();
        setStore(appStore);
      } catch (err) {
        setError(`Error initializing the app: ${err.message}`);
      } finally {
        setLoading(false);
      }
    };
    initializeStore();
  }, []);

  if (loading || !store) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Loader />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center h-screen">
        <ErrorComponent errorMessage={error} />
      </div>
    );
  }

  return (
    <Provider store={store}>
      {serverError && <ErrorComponent errorMessage={serverError} />}
      <ScrollToTop />
      <App />
    </Provider>
  );
}

export default AppContainer;
